import { Capacitor } from "@capacitor/core";
import { Device, DeviceInfo } from "@capacitor/device";

let cachedInfo: DeviceInfo | null = null;

export const getDeviceInfo = async (): Promise<DeviceInfo | null> => {
  if (cachedInfo) return cachedInfo;
  try {
    cachedInfo = await Device.getInfo();
    return cachedInfo;
  } catch {
    return null;
  }
};

export const isIpad = async (): Promise<boolean> => {
  if (!Capacitor.isNativePlatform()) return false;
  const info = await getDeviceInfo();
  if (!info) return false;
  // On iPadOS 13+ the model string starts with "iPad". Some iPads also report
  // operatingSystem "ipados", but model is the most reliable signal across versions.
  return info.platform === "ios" && /^iPad/i.test(info.model ?? "");
};

const readSafeAreaVar = (name: string): string =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim();

export const logDeviceAndViewport = async (label = "device-debug"): Promise<void> => {
  const info = await getDeviceInfo();
  const ipad =
    info?.platform === "ios" && /^iPad/i.test(info?.model ?? "");

  console.log(label, {
    platform: Capacitor.getPlatform(),
    isNative: Capacitor.isNativePlatform(),
    isIpad: ipad,
    device: info
      ? {
          model: info.model,
          operatingSystem: info.operatingSystem,
          osVersion: info.osVersion,
          manufacturer: info.manufacturer,
          isVirtual: info.isVirtual,
          webViewVersion: info.webViewVersion,
        }
      : null,
    window: {
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      devicePixelRatio: window.devicePixelRatio,
      orientation: window.screen?.orientation?.type,
    },
    screen: {
      width: window.screen?.width,
      height: window.screen?.height,
      availWidth: window.screen?.availWidth,
      availHeight: window.screen?.availHeight,
    },
    safeArea: {
      top: readSafeAreaVar("--safe-area-top"),
      bottom: readSafeAreaVar("--safe-area-bottom"),
    },
  });
};
